import React, { Component } from 'react'
import AreYouRetiredStep from './steps/AreYouRetiredStep'
import RetirementAgeStep from './steps/RetirementAgeStep'
import CurrentBudgetStep from './steps/CurrentBudgetStep'
import RetirementBudgetStep from './steps/RetirementBudgetStep'

const STEPS = [
  {
    component: AreYouRetiredStep,
    name: 'Retirement'
  },
  {
    component: RetirementAgeStep,
    name: 'Retirement age'
  },
  {
    component: CurrentBudgetStep,
    name: 'Current budget'
  },
  {
    component: RetirementBudgetStep,
    name: 'Retirement budget'
  }
]

const RETIRED_STEPS = [
  {
    component: AreYouRetiredStep,
    name: 'Retirement'
  },
  {
    component: CurrentBudgetStep,
    name: 'Current budget'
  }
]

const RETIRING_STEPS = [
  {
    component: AreYouRetiredStep,
    name: 'Retirement'
  },
  {
    component: RetirementAgeStep,
    name: 'Retirement age'
  },
  {
    component: CurrentBudgetStep,
    name: 'Current budget'
  }
]

export default class ProfileWizard extends Component {
  constructor (props) {
    super(props)

    this.state = {
      currentStep: 0,
      isRetired: props.stepConfig.isRetired || false,
      currentAgeEqlRetirementAge: false,
      tenant: props.stepConfig.tenant,
    }
    this.profileStepHeight = 48
    this.profileCurrentStepHeight = 350
  }

  componentDidUpdate () {
    let event = new CustomEvent('react-components-load')
    document.dispatchEvent(event)
  }

  onNext = () => {
    this.setState(({ currentStep }) => ({ currentStep: currentStep + 1 }))
  }

  onBack = () => {
    this.setState(({ currentStep }) => ({ currentStep: currentStep - 1 }))
  }

  getStepPosition (step) {
    if (step <= this.state.currentStep) {
      return step * this.profileStepHeight
    } else {
      return step * this.profileStepHeight + (this.profileCurrentStepHeight - this.profileStepHeight)
    }
  }

  getStepStyle (step) {
    return {
      top: `${this.getStepPosition(step)}px`
    }
  }

  stepClass (step) {
    const classNames = ['profile-wizard__step']
    if (step === this.state.currentStep) classNames.push('profile-wizard__step--current')
    if (step < this.state.currentStep) classNames.push('profile-wizard__step--previous')
    if (step > this.state.currentStep) classNames.push('profile-wizard__step--next')
    return classNames.join(' ')
  }

  onNextHandler (stepIndex) {
    if (stepIndex === STEPS.length - 1) {
      return null
    } else {
      return this.onNext
    }
  }

  onBackHandler (stepIndex) {
    if (stepIndex === 0) {
      return null
    } else {
      return this.onBack
    }
  }

  isRetiredHandler = (isRetired, currentAgeEqlRetirementAge = false) => {
    this.setState({ isRetired, currentAgeEqlRetirementAge })
  }

  stepConfig () {
    let configs = Object.assign(this.props.stepConfig, {
      isRetired: this.state.isRetired,
      isRetiredHandler: this.isRetiredHandler,
      netMonthlyRetirementBudget: this.props.stepConfig.netMonthlyRetirementBudget,
      clientId: this.props.stepConfig.clientId,
      tenant: this.state.tenant
    })
    return configs
  }

  activeSteps () {
    if (this.state.isRetired) {
      if (this.state.currentAgeEqlRetirementAge) {
        return RETIRING_STEPS
      } else {
        return RETIRED_STEPS
      }
    } else {
      return STEPS
    }
  }

  render () {
    return (
      <ul className='profile-wizard'>
        {this.activeSteps().map((Step, stepIdx) => (
          <li key={stepIdx}
            className={
              `${this.stepClass(stepIdx)}
              md:absolute md:w-[50rem]
              md:transform md:-translate-x-1/2
              md:left-[55%] lg:left-[50%]
              my-4
              `}
            style={this.getStepStyle(stepIdx)}>
            <span className='step-dot hidden md:block'>
              <svg height='32' width='32'>
                <circle cx='14' cy='14' r='14' stroke='black' strokeWidth='0' fill='red' />
              </svg>
            </span>
            <div className='step-body ml-6 xs:ml-10 sm:ml-20'>
              <h2 className='step-name px-0 xs:px-2'>
                <span className='step-name--number'>0{stepIdx}. </span><span>{Step.name}</span>
              </h2>
              <div className='step-content'>
                <Step.component onNext={this.onNextHandler(stepIdx)} onBack={this.onBackHandler(stepIdx)} stepConfig={this.stepConfig()} />
              </div>
            </div>
          </li>
        ))}
      </ul>
    )
  }
}
